import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addLiked, removeOneLiked } from "../../store/likedSlice/liked-actions";

import useWindowWidth from "../../hooks/use-windowWidth";
import downloadResource from "../../utils/download-helper";
import CollectionModal from "./CollectionModal/CollectionModal";

import { FaHeart } from "react-icons/fa";
import { AiOutlinePlus } from "react-icons/ai";
import { HiDownload } from "react-icons/hi";
import classes from "./ImageItem.module.css";

const ImageItem = (props) => {
  const width = useWindowWidth();
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const isloggedIn = useSelector((state) => state.auth.userLoggedIn);
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    document.body.style.overflow = "hidden";
    setModalOpen(true);
  };
  const closeModal = () => {
    document.body.style.overflow = "auto";
    setModalOpen(false);
  };

  const likedImages = useSelector((state) => state.liked.images);
  const isLiked = likedImages.find((image) => image.id === props.id);

  const { id, url, username, name, link } = props;
  const style = { backgroundImage: "url(" + url + ")" };

  const divHandler = (e) => {
    if (e.target.innerText !== undefined) {
      history.push({
        pathname: `/photo/${id}`,
        state: { background: location },
      });
    }
  };

  const likeHandler = () => {
    if (isloggedIn) {
      isLiked
        ? dispatch(removeOneLiked({ id }))
        : dispatch(addLiked({ id, url, username, name, link }));
    } else {
      history.push("/login");
    }
  };

  const saveHandler = () => {
    if (isloggedIn) {
      openModal();
    } else {
      history.push("/login");
    }
  };

  const downloadHandler = (e) => {
    downloadResource(`${url}`, `${username}_${id}-pixelbay.jpeg`);
  };
  return (
    <>
      <div
        className={classes[`image-container`]}
        onClick={divHandler}
        style={style}
      >
        <button
          tabIndex={0}
          className={`${isLiked ? classes.like : classes.dislike} ${
            classes.image_button
          }`}
          onClick={likeHandler}
          type="button"
        >
          <span>
            <FaHeart size={width < 768 ? 21 : 15} />
          </span>
        </button>
        <button
          type="button"
          tabIndex={0}
          className={`${classes.save} ${classes.image_button}`}
          onClick={saveHandler}
        >
          <AiOutlinePlus size={width < 768 ? 28 : 20} />
        </button>
        <button
          type="button"
          onClick={downloadHandler}
          tabIndex={0}
          className={`${classes.download} ${classes.image_button}`}
        >
          <HiDownload size={width < 768 ? 28 : 20} />
        </button>
        <h2 className={classes.credits}>
          Photo by{" "}
          <a href={link} rel="noreferrer" target="_blank">
            {name}
          </a>
        </h2>
      </div>
      {modalOpen && (
        <CollectionModal
          onClose={closeModal}
          id={id}
          url={url}
          username={username}
          name={name}
          link={link}
        />
      )}
    </>
  );
};

export default ImageItem;
